const styles = {
    root: {
        position: 'relative'
    },
    flex: {
        flex: 1
    }
};

export default styles;
